export default [
  {
    path: "/coletas",
    name: "Coletas",
    //props: (route) => ({ volumes: route.query.volumes}),
    props: (route) => (
      {
        volumes: route.params.volumes,
        idsnfs: route.params.idsnfs,
        idnfs: route.params.idnfs,
        selected: true,
      }
    ),
    component: () => import("../views"),
  },
  {
    path: "/coletasnfs",
    name: "ColetasNFS",
    props: (route) => (
      {
        idsnfs: route.params.idsnfs,
        idnfs: route.params.idnfs,
        selected: true,
      }),
    component: () => import("../views/NfsColetas"),
  },
  {
    path: "/checkcoletas",
    name: "CheckColetas",
    props: (route) => (
      {
        modalidadeid: route.params.modalidadeid,
        selected: true,
      }),
    component: () => import("../views/CheckColetas"),
  },
]